<template>
  <div :style="logoStyle">
    <svg
      :viewBox="viewBox"
      :width="computedWidth"
      :height="computedHeight"
      :style="svgStyle"
      preserveAspectRatio="xMidYMid meet"
    >
      <defs>
        <clipPath id="__lottie_element_2">
          <rect width="1460" height="550" x="0" y="0"></rect>
        </clipPath>

        <clipPath id="__lottie_element_4">
          <path d="M0,0 L4040,0 L4040,5880 L0,5880z"></path>
        </clipPath>

        <!-- ZELOS -->
        <mask id="__lottie_element_8">
          <!-- zelo[S] -->
          <path
            fill="#ffffff"
            clip-rule="nonzero"
            d="M1036.926025390625,518.739013671875 C1023.1790161132812,514.156982421875 1008.0850219726562,512 991.9119873046875,512 C958.7579956054688,512 926.1430053710938,527.364013671875 926.1430053710938,569.4130249023438 C926.1430053710938,631.677978515625 1008.6240234375,616.85400390625 1008.6240234375,652.7030029296875 C1008.6240234375,669.6840209960938 989.4869995117188,676.9619750976562 975.2009887695312,676.9619750976562 C960.3759765625,676.9619750976562 945.5499877929688,672.3790283203125 932.6119995117188,665.3709716796875 C932.6119995117188,665.3709716796875 929.1079711914062,699.333984375 929.1079711914062,699.333984375 C947.7059936523438,703.916015625 956.8720092773438,706.6119995117188 977.3569946289062,706.6119995117188 C1015.3629760742188,706.6119995117188 1047.97802734375,690.97900390625 1047.97802734375,649.7379760742188 C1047.97802734375,586.6640014648438 965.4970092773438,600.4110107421875 965.4970092773438,567.7960205078125 C965.4970092773438,547.3099975585938 982.208984375,541.6500244140625 995.14697265625,541.6500244140625 C1008.35498046875,541.6500244140625 1021.56201171875,544.614990234375 1033.4219970703125,549.7369995117188 C1033.4219970703125,549.7369995117188 1036.926025390625,518.739013671875 1036.926025390625,518.739013671875"
            fill-opacity="1"
          ></path>
          <!-- zel[O]s (outer) -->
          <path
            fill="#ffffff"
            clip-rule="nonzero"
            d="M713.4719848632812,608.7670288085938 C713.4719848632812,666.4500122070312 745.2789916992188,706.6119995117188 805.656982421875,706.6119995117188 C865.2269897460938,706.6119995117188 897.8410034179688,665.6409912109375 897.8410034179688,608.7670288085938 C897.8410034179688,551.8930053710938 864.68701171875,512 805.656982421875,512 C745.8179931640625,512 713.4719848632812,551.083984375 713.4719848632812,608.7670288085938"
            fill-opacity="1"
          ></path>
          <!-- zel[O]s (inner) -->
          <path
            fill="#000000"
            clip-rule="nonzero"
            d="M752.8259887695312,608.7670288085938 C752.8259887695312,575.6129760742188 768.1900024414062,541.6500244140625 805.656982421875,541.6500244140625 C843.1240234375,541.6500244140625 858.4879760742188,575.6129760742188 858.4879760742188,608.7670288085938 C858.4879760742188,642.72998046875 844.2020263671875,676.9619750976562 805.656982421875,676.9619750976562 C767.1119995117188,676.9619750976562 752.8259887695312,642.72998046875 752.8259887695312,608.7670288085938"
            fill-opacity="1"
          ></path>
          <!-- ze[L]os -->
          <path
            fill="#ffffff"
            clip-rule="nonzero"
            d="M587.864013671875,703.3770141601562 C587.864013671875,703.3770141601562 698.64697265625,703.3770141601562 698.64697265625,703.3770141601562 C698.64697265625,703.3770141601562 698.64697265625,673.7269897460938 698.64697265625,673.7269897460938 C698.64697265625,673.7269897460938 625.5999755859375,673.7269897460938 625.5999755859375,673.7269897460938 C625.5999755859375,673.7269897460938 625.5999755859375,515.2349853515625 625.5999755859375,515.2349853515625 C625.5999755859375,515.2349853515625 587.864013671875,515.2349853515625 587.864013671875,515.2349853515625 C587.864013671875,515.2349853515625 587.864013671875,703.3770141601562 587.864013671875,703.3770141601562"
            fill-opacity="1"
          ></path>
          <!-- z[E]los -->
          <path
            fill="#ffffff"
            clip-rule="nonzero"
            d="M437.99700927734375,703.3770141601562 C437.99700927734375,703.3770141601562 549.5880126953125,703.3770141601562 549.5880126953125,703.3770141601562 C549.5880126953125,703.3770141601562 549.5880126953125,673.7269897460938 549.5880126953125,673.7269897460938 C549.5880126953125,673.7269897460938 475.7330017089844,673.7269897460938 475.7330017089844,673.7269897460938 C475.7330017089844,673.7269897460938 475.7330017089844,620.89599609375 475.7330017089844,620.89599609375 C475.7330017089844,620.89599609375 542.8499755859375,620.89599609375 542.8499755859375,620.89599609375 C542.8499755859375,620.89599609375 542.8499755859375,591.2459716796875 542.8499755859375,591.2459716796875 C542.8499755859375,591.2459716796875 475.7330017089844,591.2459716796875 475.7330017089844,591.2459716796875 C475.7330017089844,591.2459716796875 475.7330017089844,544.8839721679688 475.7330017089844,544.8839721679688 C475.7330017089844,544.8839721679688 549.0490112304688,544.8839721679688 549.0490112304688,544.8839721679688 C549.0490112304688,544.8839721679688 549.0490112304688,515.2349853515625 549.0490112304688,515.2349853515625 C549.0490112304688,515.2349853515625 437.99700927734375,515.2349853515625 437.99700927734375,515.2349853515625 C437.99700927734375,515.2349853515625 437.99700927734375,703.3770141601562 437.99700927734375,703.3770141601562"
            fill-opacity="1"
          ></path>
          <!-- [Z]elos -->
          <path
            fill="#ffffff"
            clip-rule="nonzero"
            d="M276,703.3770141601562 C276,703.3770141601562 406.4599914550781,703.3770141601562 406.4599914550781,703.3770141601562 C406.4599914550781,703.3770141601562 406.4599914550781,673.7269897460938 406.4599914550781,673.7269897460938 C406.4599914550781,673.7269897460938 315.35400390625,673.7269897460938 315.35400390625,673.7269897460938 C315.35400390625,673.7269897460938 404.572998046875,545.9630126953125 404.572998046875,545.9630126953125 C404.572998046875,545.9630126953125 404.572998046875,515.2349853515625 404.572998046875,515.2349853515625 C404.572998046875,515.2349853515625 279.5039978027344,515.2349853515625 279.5039978027344,515.2349853515625 C279.5039978027344,515.2349853515625 279.5039978027344,544.8839721679688 279.5039978027344,544.8839721679688 C279.5039978027344,544.8839721679688 364.4110107421875,544.8839721679688 364.4110107421875,544.8839721679688 C364.4110107421875,544.8839721679688 276,672.6489868164062 276,672.6489868164062 C276,672.6489868164062 276,703.3770141601562 276,703.3770141601562"
            fill-opacity="1"
          ></path>
        </mask>

        <!-- INSIDE -->
        <mask id="__lottie_element_11">
          <!-- insid[E] (outer) -->
          <!-- <path 
                    fill="#ffffff" 
                    clip-rule="nonzero" 
                    d="M1036.64404296875,816.489990234375 C1030.9139404296875,819.698974609375 1024.4959716796875,822.4500122070312 1017.0469970703125,822.4500122070312 C1007.5339965820312,822.4500122070312 1000.8870239257812,817.06298828125 1000.198974609375,807.551025390625 C1000.198974609375,807.551025390625 1041,807.551025390625 1041,807.551025390625 C1041,786.9210205078125 1034.81103515625,771.906982421875 1012.9210205078125,771.906982421875 C994.5830078125,771.906982421875 985.5289916992188,786.0040283203125 985.5289916992188,803.0809936523438 C985.5289916992188,822.4500122070312 996.8759765625,833.6810302734375 1016.3590087890625,833.6810302734375 C1024.6109619140625,833.6810302734375 1031.029052734375,832.0759887695312 1036.64404296875,828.9819946289062 C1036.64404296875,828.9819946289062 1036.64404296875,816.489990234375 1036.64404296875,816.489990234375" 
                    fill-opacity="1">
                </path> -->
          <!-- insid[E] (inner) -->
          <!-- <path 
                    :fill="isDarkMode ? '#FFFFFF' : '#000000'" 
                    clip-rule="nonzero" 
                    d="M1000.198974609375,797.0059814453125 C1000.8870239257812,789.0980224609375 1005.2429809570312,783.1389770507812 1013.8380126953125,783.1389770507812 C1022.4329833984375,783.1389770507812 1025.8709716796875,789.5560302734375 1026.3299560546875,797.0059814453125 C1026.3299560546875,797.0059814453125 1000.198974609375,797.0059814453125 1000.198974609375,797.0059814453125" 
                    fill-opacity="1">
                </path> -->
          <!-- insi[D]e (outer) -->
          <!-- <path 
                    fill="#ffffff" 
                    clip-rule="nonzero" 
                    d="M958.5960083007812,832.3060302734375 C958.5960083007812,832.3060302734375 973.4959716796875,832.3060302734375 973.4959716796875,832.3060302734375 C973.4959716796875,832.3060302734375 973.4959716796875,746.3489990234375 973.4959716796875,746.3489990234375 C973.4959716796875,746.3489990234375 958.1380004882812,746.3489990234375 958.1380004882812,746.3489990234375 C958.1380004882812,746.3489990234375 958.1380004882812,780.1589965820312 958.1380004882812,780.1589965820312 C958.1380004882812,780.1589965820312 957.9089965820312,780.1589965820312 957.9089965820312,780.1589965820312 C953.3250122070312,774.5430297851562 947.93798828125,771.906982421875 940.2589721679688,771.906982421875 C922.1510009765625,771.906982421875 915.5040283203125,786.3469848632812 915.5040283203125,802.6220092773438 C915.5040283203125,818.781982421875 922.1510009765625,833.6810302734375 940.2589721679688,833.6810302734375 C947.47900390625,833.6810302734375 953.7830200195312,831.3889770507812 958.3670043945312,825.6589965820312 C958.3670043945312,825.6589965820312 958.5960083007812,825.6589965820312 958.5960083007812,825.6589965820312 C958.5960083007812,825.6589965820312 958.5960083007812,832.3060302734375 958.5960083007812,832.3060302734375" 
                    fill-opacity="1">
                </path> -->
          <!-- insi[D]e (inner) -->
          <!-- <path 
                    :fill="isDarkMode ? '#FFFFFF' : '#000000'" 
                    clip-rule="nonzero" 
                    d="M931.5490112304688,802.6220092773438 C931.5490112304688,794.7139892578125 934.2999877929688,783.8259887695312 944.27099609375,783.8259887695312 C954.1270141601562,783.8259887695312 958.0239868164062,794.3699951171875 958.0239868164062,802.6220092773438 C958.0239868164062,810.989013671875 954.7000122070312,821.7620239257812 944.5,821.7620239257812 C934.4140014648438,821.7620239257812 931.5490112304688,810.7589721679688 931.5490112304688,802.6220092773438" 
                    fill-opacity="1">
                </path> -->
          <!-- ins[I]de (dot) -->
          <!-- <path 
                    fill="#ffffff" 
                    clip-rule="nonzero" 
                    d="M887.7689819335938,762.5089721679688 C887.7689819335938,762.5089721679688 903.1259765625,762.5089721679688 903.1259765625,762.5089721679688 C903.1259765625,762.5089721679688 903.1259765625,747.8389892578125 903.1259765625,747.8389892578125 C903.1259765625,747.8389892578125 887.7689819335938,747.8389892578125 887.7689819335938,747.8389892578125 C887.7689819335938,747.8389892578125 887.7689819335938,762.5089721679688 887.7689819335938,762.5089721679688" 
                    fill-opacity="1">
                </path> -->
          <!-- ins[I]de (body) -->
          <!-- <path 
                    fill="#ffffff" 
                    clip-rule="nonzero" 
                    d="M887.7689819335938,832.3060302734375 C887.7689819335938,832.3060302734375 903.1259765625,832.3060302734375 903.1259765625,832.3060302734375 C903.1259765625,832.3060302734375 903.1259765625,773.281982421875 903.1259765625,773.281982421875 C903.1259765625,773.281982421875 887.7689819335938,773.281982421875 887.7689819335938,773.281982421875 C887.7689819335938,773.281982421875 887.7689819335938,832.3060302734375 887.7689819335938,832.3060302734375" 
                    fill-opacity="1">
                </path> -->
          <!-- in[S]ide -->
          <!-- <path 
                    fill="#ffffff" 
                    clip-rule="nonzero" 
                    d="M872.64501953125,774.083984375 C867.8309936523438,773.052978515625 863.1320190429688,771.906982421875 855.9119873046875,771.906982421875 C843.8779907226562,771.906982421875 832.760986328125,777.5230102539062 832.760986328125,790.2449951171875 C832.760986328125,811.56201171875 859.4650268554688,803.6530151367188 859.4650268554688,815.22900390625 C859.4650268554688,820.958984375 853.2760009765625,822.4500122070312 849.3790283203125,822.4500122070312 C844.1069946289062,822.4500122070312 839.0640258789062,820.9600219726562 834.2509765625,818.552978515625 C834.2509765625,818.552978515625 833.333984375,831.1599731445312 833.333984375,831.1599731445312 C838.9500122070312,832.6500244140625 844.9099731445312,833.6810302734375 850.7550048828125,833.6810302734375 C863.2470092773438,833.6810302734375 875.510009765625,828.1799926757812 875.510009765625,814.427001953125 C875.510009765625,793.1099853515625 848.8060302734375,799.0700073242188 848.8060302734375,789.6719970703125 C848.8060302734375,784.6290283203125 853.7340087890625,783.1389770507812 857.8599853515625,783.1389770507812 C863.4760131835938,783.1389770507812 866.9140014648438,784.0560302734375 871.6129760742188,785.6599731445312 C871.6129760742188,785.6599731445312 872.64501953125,774.083984375 872.64501953125,774.083984375" 
                    fill-opacity="1">
                </path> -->
          <!-- i[N]]side -->
          <!-- <path 
                    fill="#ffffff" 
                    clip-rule="nonzero" 
                    d="M766.5170288085938,832.3060302734375 C766.5170288085938,832.3060302734375 781.875,832.3060302734375 781.875,832.3060302734375 C781.875,832.3060302734375 781.875,803.4249877929688 781.875,803.4249877929688 C781.875,795.8610229492188 784.281005859375,783.8259887695312 795.3980102539062,783.8259887695312 C805.2540283203125,783.8259887695312 805.3690185546875,793.5679931640625 805.3690185546875,800.7890014648438 C805.3690185546875,800.7890014648438 805.3690185546875,832.3060302734375 805.3690185546875,832.3060302734375 C805.3690185546875,832.3060302734375 820.7260131835938,832.3060302734375 820.7260131835938,832.3060302734375 C820.7260131835938,832.3060302734375 820.7260131835938,795.0579833984375 820.7260131835938,795.0579833984375 C820.7260131835938,781.7630004882812 814.6519775390625,771.906982421875 800.6699829101562,771.906982421875 C792.6480102539062,771.906982421875 786.1160278320312,774.5430297851562 781.302001953125,781.3049926757812 C781.302001953125,781.3049926757812 781.072021484375,781.3049926757812 781.072021484375,781.3049926757812 C781.072021484375,781.3049926757812 781.072021484375,773.281982421875 781.072021484375,773.281982421875 C781.072021484375,773.281982421875 766.5170288085938,773.281982421875 766.5170288085938,773.281982421875 C766.5170288085938,773.281982421875 766.5170288085938,832.3060302734375 766.5170288085938,832.3060302734375" 
                    fill-opacity="1">
                </path> -->
          <!-- [I]nside (dot) -->
          <!-- <path 
                    fill="#ffffff" 
                    clip-rule="nonzero" 
                    d="M735,762.5089721679688 C735,762.5089721679688 750.3579711914062,762.5089721679688 750.3579711914062,762.5089721679688 C750.3579711914062,762.5089721679688 750.3579711914062,747.8389892578125 750.3579711914062,747.8389892578125 C750.3579711914062,747.8389892578125 735,747.8389892578125 735,747.8389892578125 C735,747.8389892578125 735,762.5089721679688 735,762.5089721679688" 
                    fill-opacity="1">
                </path> -->
          <!-- [I]nside (body) -->
          <!-- <path 
                    fill="#ffffff" 
                    clip-rule="nonzero" 
                    d="M735,832.3060302734375 C735,832.3060302734375 750.3579711914062,832.3060302734375 750.3579711914062,832.3060302734375 C750.3579711914062,832.3060302734375 750.3579711914062,773.281982421875 750.3579711914062,773.281982421875 C750.3579711914062,773.281982421875 735,773.281982421875 735,773.281982421875 C735,773.281982421875 735,832.3060302734375 735,832.3060302734375" 
                    fill-opacity="1">
                </path> -->
        </mask>

        <filter id="__lottie_element_12">
          <feColorMatrix
            type="matrix"
            color-interpolation-filters="linearRGB"
            values="0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0"
            result="f1"
          ></feColorMatrix>
          <feColorMatrix
            type="matrix"
            color-interpolation-filters="sRGB"
            values="0.5176470279693604 0 0 0 0.48235297203063965 0.4901960492134094 0 0 0 0.5098039507865906 0.4745097756385803 0 0 0 0.5254902243614197 0 0 0 1 0"
            result="f2"
          ></feColorMatrix>
        </filter>

        <clipPath id="__lottie_element_15">
          <path
            fill="#ffffff"
            clip-rule="nonzero"
            d="M1931.263671875,2942.04736328125 C1931.263671875,2942.04736328125 1966.832763671875,2846.373779296875 1966.832763671875,2846.373779296875 C1966.832763671875,2846.373779296875 2073.78564453125,2851.7939453125 2073.78564453125,2851.7939453125 C2073.78564453125,2851.7939453125 2069.19677734375,3040.6806640625 2069.19677734375,3040.6806640625 C2069.19677734375,3040.6806640625 1931.263671875,2942.04736328125 1931.263671875,2942.04736328125"
            fill-opacity="1"
          ></path>
        </clipPath>

        <clipPath id="__lottie_element_18">
          <path
            fill="#ffffff"
            clip-rule="nonzero"
            d="M1880.387451171875,2987.28955078125 C1880.387451171875,2987.28955078125 2073.786376953125,2851.7939453125 2073.786376953125,2851.7939453125 C2073.786376953125,2851.7939453125 1931.3699951171875,2941.958251953125 1931.3699951171875,2941.958251953125 C1931.3699951171875,2941.958251953125 1880.387451171875,2987.28955078125 1880.387451171875,2987.28955078125"
            fill-opacity="1"
          ></path>
        </clipPath>

        <clipPath id="__lottie_element_21">
          <path
            fill="#ffffff"
            clip-rule="nonzero"
            d="M1931.2706298828125,2942.046630859375 C1931.2706298828125,2942.046630859375 2069.169921875,3040.50341796875 2069.169921875,3040.50341796875 C2069.169921875,3040.50341796875 1880.249755859375,2987.3779296875 1880.249755859375,2987.3779296875 C1880.249755859375,2987.3779296875 1931.2706298828125,2942.046630859375 1931.2706298828125,2942.046630859375"
            fill-opacity="1"
          ></path>
        </clipPath>

        <clipPath id="__lottie_element_24">
          <path
            fill="#ffffff"
            clip-rule="nonzero"
            d="M1931.318359375,2942.065185546875 C1931.318359375,2942.065185546875 2135.71435546875,2945.651611328125 2135.71435546875,2945.651611328125 C2135.71435546875,2945.651611328125 2069.24365234375,3040.540283203125 2069.24365234375,3040.540283203125 C2069.24365234375,3040.540283203125 1931.318359375,2942.065185546875 1931.318359375,2942.065185546875"
            fill-opacity="1"
          ></path>
        </clipPath>

        <clipPath id="__lottie_element_27">
          <path
            fill="#ffffff"
            clip-rule="nonzero"
            d="M1931.4014892578125,2942.064697265625 C1931.4014892578125,2942.064697265625 2135.703369140625,2945.828125 2135.703369140625,2945.828125 C2135.703369140625,2945.828125 1966.5341796875,2846.019775390625 1966.5341796875,2846.019775390625 C1966.5341796875,2846.019775390625 1931.4014892578125,2942.064697265625 1931.4014892578125,2942.064697265625"
            fill-opacity="1"
          ></path>
        </clipPath>
      </defs>

      <g clip-path="url(#__lottie_element_2)">
        <g
          clip-path="url(#__lottie_element_4)"
          style="display: block"
          transform="matrix(0.18000000715255737,0,0,0.18000000715255737,800.4000244140625,-278.20001220703125)"
          opacity="1"
        >
          <g
            clip-path="url(#__lottie_element_15)"
            style="display: block"
            transform="matrix(10,0,0,10,-18180,-26460)"
            opacity="0.75"
          >
            <rect width="4040" height="5880" fill="#71be57"></rect>
          </g>
          <g
            clip-path="url(#__lottie_element_18)"
            style="display: block"
            transform="matrix(10,0,0,10,-18180,-26460)"
            opacity="0.75"
          >
            <rect width="4040" height="5880" fill="#cfbb40"></rect>
          </g>
          <g
            clip-path="url(#__lottie_element_21)"
            style="display: block"
            transform="matrix(10,0,0,10,-18180,-26460)"
            opacity="0.75"
          >
            <rect width="4040" height="5880" fill="#6a9edc"></rect>
          </g>
          <g
            clip-path="url(#__lottie_element_24)"
            style="display: block"
            transform="matrix(10,0,0,10,-18180,-26460)"
            opacity="0.75"
          >
            <rect width="4040" height="5880" fill="#925ca4"></rect>
          </g>
          <g
            clip-path="url(#__lottie_element_27)"
            style="display: block"
            transform="matrix(10,0,0,10,-18180,-26460)"
            opacity="0.75"
          >
            <rect width="4040" height="5880" fill="#df3e5c"></rect>
          </g>
        </g>
        <g
          mask="url(#__lottie_element_8)"
          style="display: block"
          transform="matrix(1,0,0,1,-276,-287)"
          opacity="1"
        >
          <rect width="1920" height="1080" :fill="isDarkMode ? '#FFFFFF' : '#000000'"></rect>
        </g>
        <g
          mask="url(#__lottie_element_11)"
          filter="url(#__lottie_element_12)"
          style="display: block"
          transform="matrix(1,0,0,1,-276,-287)"
          opacity="1"
        >
          <rect width="1920" height="1080" :fill="isDarkMode ? '#FFFFFF' : '#000000'"></rect>
        </g>
      </g>
    </svg>
  </div>
</template>

<script lang="ts">
export default {
  name: 'ZelosLogo',
  props: {
    width: {
      type: Number,
      required: true,
    },
    animated: {
      type: Boolean,
      default: false,
    },
    isDarkMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    computedWidth(): number {
      return Number(this.width);
    },
    computedHeight(): number {
      return Number(this.width) / (1460 / 550); // Calculate height maintaining aspect ratio
    },
    viewBox() {
      return '0 0 1460 550';
    },
    logoStyle() {
      const w = Number(this.width);
      const h = w / (1460 / 550);
      return {
        width: `${w}px`,
        height: `${h}px`,
      };
    },
    svgStyle() {
      return {
        transform: this.animated ? 'scale(1.1)' : 'none',
        transition: this.animated ? 'transform 0.3s ease-in-out' : 'none',
      };
    },
  },
};
</script>
